import { type Application } from "@/lib/backend/api";
import { type UpcomingShiftItem } from "@/lib/hooks/use-upcoming-shifts-overview";

/**
 * Aanmeldingen die niets meer gaan worden.
 *
 * "Daarna" beantwoordt één vraag: wat komt er nog aan. Een afgewezen of geannuleerde aanmelding
 * hoort daar niet meer bij — die stond tussen het echte werk en maakte de lijst langer dan de
 * inhoud rechtvaardigt. `CONSUMED` is een aanmelding die al een dienst geworden is; die dienst
 * staat er zelf al. `CANCELLATION_REQUESTED` staat op de dienstkaart.
 *
 * Bewust een uitsluitlijst en geen toelaatlijst: komt er ooit een status bij in de api, dan
 * verschijnt die hier gewoon in plaats van stilzwijgend te verdwijnen. Iets te veel tonen is een
 * rommelige lijst; iets te weinig tonen is een medewerker die niet weet dat hij ergens verwacht
 * wordt.
 */
const NOT_UPCOMING = new Set<Application["status"]>([
  "REJECTED",
  "CANCELLED",
  "CONSUMED",
  "CANCELLATION_REQUESTED",
]);

export function isStillUpcoming(item: UpcomingShiftItem): boolean {
  if (item.type === "shift") {
    return true;
  }

  return !NOT_UPCOMING.has(item.application.status);
}

/** Wat er onder "Daarna" komt te staan: alleen wat nog kan gebeuren, en niet meer dan `limit`. */
export function upNextItems(
  items: UpcomingShiftItem[],
  { exclude, limit }: { exclude?: UpcomingShiftItem; limit: number },
): UpcomingShiftItem[] {
  return items
    .filter((item) => item !== exclude)
    .filter(isStillUpcoming)
    .slice(0, limit);
}
